import React from 'react';
import styled from 'styled-components';
const SequenceImage = styled.div `
  width: ${(props) => props.frameWidth}px;
  height: ${(props) => props.frameHeight}px;
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  animation-duration: ${(props) => props.duration};
  animation-name: ${(props) => props.direction !== -1 ? props.animationInName : props.animationOutName};
  animation-timing-function: steps(${(props) => props.frameCount});
  animation-fill-mode: forwards;

  ${(props) => props.frameScale
    ? `
    transform-origin: left top;
    transform: scale(${props.frameScale});
  `
    : ''}

  @keyframes ${(props) => props.animationInName} {
    from {
      background-position-${(props) => props.frameDirection}: 0;
    }
    to {
      background-position-${(props) => props.frameDirection}: -${(props) => props.frameSize}px;
    }
  }

  @keyframes ${(props) => props.animationOutName} {
    from {
      background-position-${(props) => props.frameDirection}: -${(props) => props.frameSize}px;
    }
    to {
      background-position-${(props) => props.frameDirection}: 0;
    }
  }
`;
export default function SequenceImageComponent(props) {
    const { sequence, ...rest } = props;
    if (!sequence.frameDirection) {
        sequence.frameDirection = 'y';
    }
    if (!sequence.duration) {
        sequence.duration = '1s';
    }
    sequence.frameCount -= 1;
    let frameSize;
    if (sequence.frameDirection === 'y') {
        frameSize = sequence.frameCount * sequence.frameHeight;
    }
    else {
        frameSize = sequence.frameCount * sequence.frameWidth;
    }
    const animationPrefix = [sequence.frameDirection, frameSize].join('-');
    const animationInName = `ia-${animationPrefix}-sequence-in`;
    const animationOutName = `ia-${animationPrefix}-sequence-out`;
    return (React.createElement(SequenceImage, { ...sequence, ...rest, frameSize: frameSize, animationInName: animationInName, animationOutName: animationOutName }));
}
